/* The clock switch is a device setting: the console restores it at load and keeps every
   change, through the one browser-storage boundary. */

import { currentClock, setClock, subscribeClock, type Clock } from "@sx/ui";

import { readBrowserValue, writeBrowserValue } from "./browser-storage";

const SETTING = "clock";
const DEVICE = { kind: "device" } as const;

/** Restores the saved clock and saves each change; call once, before the shell renders. */
export function keepClockSetting(): () => void {
  const saved = readBrowserValue<Clock>(DEVICE, SETTING, (value) =>
    value === "local" || value === "utc" ? value : undefined,
  );
  if (saved !== undefined) setClock(saved);
  return subscribeClock(() => {
    writeBrowserValue(DEVICE, SETTING, currentClock());
  });
}
